import React from 'react'
import css from './Hero.module.css'
import HeroImg from '../../assets/hero.png'
import { RiShoppingBagFill } from 'react-icons/ri'
import { BsArrowRight } from 'react-icons/bs'
import { motion } from 'framer-motion';
 
const Hero = () => {

    const transition = {duration: 3, type: "spring", stiffness: 100}
  return (
    <div className={css.container}>
      

        {/* Hero left side */}
        <div className={css.h_sides}>
            <span className={css.text1}>Skin protection cream</span>

            <div className={css.text2}>
                <span>Trendy Collection</span>
                <span>Get the best affordable makeup from our fine store. Good offers today!</span>
            </div>
        </div>

        {/* Hero middle side */}
        <div className={css.wrapper}>
            {/* Blue circle */}
            <motion.div
             initial={{bottom: "2rem"}}
             whileInView={{bottom: "0rem"}}
             className={css.blueCircle}
             transition={transition}
             >
            </motion.div>


            <motion.img
            transition={transition}
            initial={{bottom: "-2rem"}}
            whileInView={{bottom: "0rem"}}
             src={HeroImg} alt="hero"  width={600}/>


            <motion.div
            transition={transition}
            initial={{right: "4%"}}
            whileInView={{right: "2%"}} 
            className={css.cart2}>
                <RiShoppingBagFill />

                <div className={css.signup}>
                    <span>Best Sign up Offers</span>
                    <div> 
                        <BsArrowRight />
                    </div>
                </div>
            </motion.div>
        </div>

        {/* Hero right side */}
        <div className={css.h_sides}>
            <div className={css.traffic}>
                {/* <span>Free Shipping</span> */}
                <span>1.5m</span>
                {/* <span>On all orders over $75.00 </span> */}
                <span>Monthly Traffic</span>
            </div>

        <div className={css.customers}>
                <span>100K+</span>
                <span>Happy Customers</span>
        </div>
        </div>

    </div>
  )
}

export default Hero
